import React, { Fragment, useState, useEffect } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import HeaderCard from '../../../Common/Component/HeaderCard';
import config from '../../../../config';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const MonthOnMonthTable = ({ year, propertyMallCode }) => {
    const { t } = useTranslation();
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_id = localStorage.getItem("propertyAccess");
    const token = localStorage.getItem("sessiontoken");
    const currentYear = new Date().getFullYear();
    const selectedYear = year === '' ? currentYear : year;
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const [currentYearData, setCurrentYearData] = useState([]);
    const [previousYearData, setPreviousYearData] = useState([]);
    const [apiUrl, setApiUrl] = useState('');
    const [apiData, setApiData] = useState([]);

    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };
    // const [tabledata, setTableData] = useState([]);

    useEffect(() => {
        if (year !== '' || propertyMallCode !== '') {
            setApiUrl('dashboardfiltered/salescomparisonmomtable')
            const data1 = {
                concessionaire_id,
                property_id,
                year,
                propertyMallCode
            }
            setApiData(data1)
        }
        else {
            setApiUrl('dashboard/salescomparisonmomtable')
            const data2 = {
                concessionaire_id,
                property_id
            }
            setApiData(data2)
        }
    }, [year, propertyMallCode]);


    useEffect(() => {
        if (apiUrl !== '') {
            axios
                .post(`${config.hostname}/${apiUrl}`, apiData, configheader)
                .then((response) => {
                    setCurrentYearData(transformSalesData(response.data.currentYearSales));
                    setPreviousYearData(transformSalesData(response.data.previousYearSales));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [apiUrl, apiData]);

    const transformSalesData = (salesData) => {
        return salesData.reduce((acc, item) => {
            acc[item.month] = {
                totalSales: item.totalSales,
                percentageChange: item.percentageChange
            };
            return acc;
        }, {});
    };



    const rows = [
        { year: selectedYear - 1, data: previousYearData },
        { year: selectedYear, data: currentYearData },
    ];

    const renderCell = (value) => {
        if (!value || value.totalSales == null) return <span className="dash-muted">—</span>;
        const pc = value.percentageChange;
        const dir = pc > 0 ? 'up' : pc < 0 ? 'down' : 'flat';
        const arrow = pc > 0 ? '↑' : pc < 0 ? '↓' : '';
        return (
            <>
                <div className="dash-val">{value.totalSales}</div>
                {pc != null && pc !== '' && (
                    <div className={`dash-delta ${dir}`}>{arrow} {Math.abs(pc)}%</div>
                )}
            </>
        );
    };

    return (
        <Fragment>
            <Col sm='12' >
                <Card>
                    <HeaderCard title={<div><div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>{t('Sales Analysis')}</div>
                        <div style={{ fontSize: '0.7em', color: '#777', marginLeft: '10px' }}>{t('Month on month')}</div>
                    </div>
                        <div style={{ fontSize: '0.6em', color: '#777' }}>{t('Values in millions')}</div></div>} />
                    <CardBody>
                        <div className="dash-table-wrap">
                            <table className="dash-table">
                                <thead>
                                    <tr>
                                        <th>{t('Year')}</th>
                                        {monthNames.map((m) => <th key={m}>{t(m.substr(0, 3))}</th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r) => (
                                        <tr key={r.year}>
                                            <td className="dash-row-head">{r.year}</td>
                                            {monthNames.map((m) => (
                                                <td key={m}>{renderCell(r.data[m])}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default MonthOnMonthTable